/**
 * 编辑视图模块路由
 */
export default [
  {
    path: "/menu",
    component: resolve => require(["@/views/menu.vue"], resolve),
    redirect: "/menu/home",
    children: [
      {
        path: "autoweb",  // 使用相对路径
        component: resolve => require(["@/modules/autoweb/pages/index.vue"], resolve),
        redirect: "/menu/autoweb/list",
        children: [
          {
            path: "list",
            component: resolve => require(["@/modules/autoweb/pages/list.vue"], resolve)
          },
          {
            path: "type",
            component: resolve => require(["@/modules/autoweb/pages/type.vue"], resolve)
          },
          {
            path: "module",
            component: resolve => require(["@/modules/autoweb/pages/module.vue"], resolve)
          },
          {
            path: "channel/:id/:code",
            component: resolve => require(["@/modules/autoweb/pages/channel.vue"], resolve)
          },
          {
            path: "design/web/:id",   // 合并不同语言版本
            component: resolve => require(["@/modules/autoweb/pages/design/web.vue"], resolve)
          },
          {
            path: "design/phone/:id",  // 合并不同语言版本
            component: resolve => require(["@/modules/autoweb/pages/design/phone.vue"], resolve)
          },
          {
            path: "designWebComponent/:id",
            component: resolve => require(["@/modules/autoweb/pages/design/webComponent.vue"], resolve)
          },
          {
            path: "designPhoneComponent/:id",
            component: resolve => require(["@/modules/autoweb/pages/design/phoneComponent.vue"], resolve)
          }
        ]
      }
    ]
  }
];
